<template>
  <ErrorModal />
  <q-dialog v-model="shareNewsItem" class="share-grant-main">
    <q-card class="share-dialog">
      <q-form
        @submit="shareNewsItemEmit(name, organisation, address, newsItem.id)"
      >
        <q-card-section>
          <div class="text-h5">Item delen</div>
        </q-card-section>
        <q-card-section>
          <div class="share-text">
            <div class="row">
              <div class="column">
                <div class="row">
                  <div class="column">
                    <span class="share-info bold">
                      Te delen item:
                    </span>

                    <span class="share-info">
                      {{ newsItem.title }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </q-card-section>
        <q-card-section>
          <div class="share-text-sm">
            <span class="share-info">
              Naam
            </span>
            <q-input
              class="q-mt-sm"
              outlined
              v-model="name"
              dense
              :rules="requiredFieldRule"
              label="Voeg een naam toe"
            />
          </div>

          <div class="share-text-sm q-mt-md">
            <span class="share-info">
              Organisatie
            </span>
            <q-input
              class="q-mt-sm"
              outlined
              v-model="organisation"
              dense
              :rules="requiredFieldRule"
              label="Voeg een organisatie"
            />
          </div>
          <div class="share-text-sm q-mt-md">
            <span class="share-info">
              Emailadres
            </span>
            <q-input
              class="q-mt-sm"
              outlined
              v-model="address"
              dense
              type="email"
              :rules="[isValidEmail, requiredFieldRule]"
              label="Voeg een e-mailadres toe"
            />
          </div>
        </q-card-section>

        <q-card-actions class="q-mt-sm" align="left">
          <q-btn
            flat
            label="Delen"
            class="submit-btn"
            color="white"
            no-caps
            type="submit"
          />
          <q-btn
            flat
            label="Annuleren"
            no-caps
            class="cancel-btn"
            v-close-popup
          />
        </q-card-actions>
      </q-form>
    </q-card>
  </q-dialog>
</template>

<script>
import { computed, ref } from 'vue';
import store from '../../store/index';
import MailingService from '../../services/mailing.service';
import ErrorModal from './ErrorModal.vue';

export default {
  components: {
    ErrorModal,
  },
  setup() {
    const shareNewsItem = computed({
      get: () => store.state.news.shareNewsItem,
      set: (val) => store.commit('news/disableShareNews', val),
    });

    const newsItem = computed({
      get: () => store.state.news.newsItemToShare,
    });

    const shareNewsItemEmit = async (name, organisation, address, id) => {
      MailingService.shareNews(name, organisation, address, id);
    };

    const address = ref('');
    const organisation = ref('');

    const name = ref('');
    return {
      name,
      organisation,
      address,
      shareNewsItem,
      newsItem,
      shareNewsItemEmit,
      requiredFieldRule: [
        (val) => (val && val.length > 0) || 'Veld is verplicht!',
      ],
      isValidEmail(val) {
        const emailPattern = /^(?=[a-zA-Z0-9@._%+-]{6,254}$)[a-zA-Z0-9._%+-]{1,64}@(?:[a-zA-Z0-9-]{1,63}\.){1,8}[a-zA-Z]{2,63}$/;
        return emailPattern.test(val) || 'Ongeldig e-mailadres';
      },
    };
  },
};
</script>
